import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import classNames from "classnames";

import Loading from "../../components/Loading";
import { ILeagueSummary } from "../../types/api";
import { AsyncStatuses } from "../../types/shared";

interface Props {
    summary: ILeagueSummary | undefined;
    fetchStatus: AsyncStatuses;
}

const LeagueSummary = ({ fetchStatus, summary }: Props): React.JSX.Element => {
    return (
        <React.Fragment>
            {fetchStatus === "pending" && (
                <React.Fragment>
                    <h5>Fetching league summary...</h5>
                    <Loading />
                </React.Fragment>
            )}
            {fetchStatus === "success" && summary && (
                <Table striped bordered>
                    <thead>
                        <tr>
                            <th>Team</th>
                            <th>Logo</th>
                            <th>COI Approved</th>
                            <th>Players (accepted waiver / total)</th>
                            <th>Home Games Scheduled</th>
                        </tr>
                    </thead>
                    <tbody>
                        {summary.teams.map(t => (
                            <tr key={t.id}>
                                <td>
                                    <Link
                                        to={`/coachs-clubhouse/team/${t.id}`}
                                        target="_blank"
                                    >
                                        {t.name}
                                    </Link>
                                </td>
                                <td>{t.logo}</td>
                                <td>{t.coiApproved}</td>
                                <td>
                                    <Link
                                        to={`/coachs-clubhouse/team/${t.id}/roster`}
                                        target="_blank"
                                    >
                                        {t.players.waiverAccepted} /{" "}
                                        {t.players.count}
                                    </Link>
                                </td>
                                <td>
                                    {" "}
                                    <Link
                                        to={`/coachs-clubhouse/team/${t.id}/schedule`}
                                        target="_blank"
                                    >
                                        {t.homeGames}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </React.Fragment>
    );
};

export default LeagueSummary;
